import * as _ from "lodash";
import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ManualOrderActionEntityParams {
  action_result?: boolean;
  action_type:
    | "clicks_text_rep"
    | "clicks_email_rep"
    | "clicks_copy_order"
    | "clicks_download_pdf"
    | "clicks_mark_as_sent";
}
export class ManualOrderActionEntity extends BaseEntityClass {
  action_type: ManualOrderActionEntityParams["action_type"];
  action_result: ManualOrderActionEntityParams["action_result"];
  constructor(params: ManualOrderActionEntityParams) {
    super();
    this.type = "manual_order_action";
    this.entity_version = 3;
    this.action_type = params.action_type;
    this.action_result = params.action_result;
  }

  static fromManualOrderAction(manual_order_action: any): ManualOrderActionEntity {
    manual_order_action = _.pick(manual_order_action, ["action_type"]);

    return new ManualOrderActionEntity(manual_order_action);
  }
}
